module.exports = __webpack_public_path__ + "media/trail/icons-controls-compass-15e20244.svg";